import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './GoldPage.css';
import API_BASE_URL from './config';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';



const GoldPage = () => {
  const email = localStorage.getItem('user_email');

  const [profile, setProfile] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [pinCode, setPinCode] = useState('');
  const [address, setAddress] = useState('');

  const [transactions, setTransactions] = useState([]);
  const [portfolio, setPortfolio] = useState(null);

  const [showBuyModal, setShowBuyModal] = useState(false);
  const [buyMode, setBuyMode] = useState("INR");
  const [buyValue, setBuyValue] = useState("");
  const [confirmationData, setConfirmationData] = useState(null);




  useEffect(() => {
    if (email) {
      axios.get(`${API_BASE_URL}/api/gold/user-info`, { params: { email } })
        .then(res => setProfile(res.data))
        .catch(err => {
          // Step 2: If not found, fallback to combined
          if (err.response?.status === 404) {
            axios.get(`${API_BASE_URL}/api/gold/combined-user-info`, { params: { email } })
              .then(res => {
                const data = res.data;
                // Check if anything missing
                if (!data.name || !data.mobile_no || !data.pin_code || !data.delivery_address) {
                  setShowProfileModal(true);
                }
                setProfile(data);
              })
              .catch(() => {
                alert("Failed to load user info");
              });
          }
        });

      axios.get(`${API_BASE_URL}/api/gold/transactions`, { params: { email } })
        .then(res => setTransactions(res.data))
        .catch(err => {
          console.error("Failed to fetch transactions", err);
        });

      axios.get(`${API_BASE_URL}/api/gold/portfolio`, { params: { email } })
        .then(res => {
          setPortfolio(res.data);
        })
        .catch(err => console.error("Portfolio fetch failed", err));
    }
  }, [email]);

  const fetchPortfolio = () => {
    axios.get(`${API_BASE_URL}/api/gold/portfolio`, { params: { email } })
      .then(res => setPortfolio(res.data))
      .catch(err => console.error("Failed to fetch portfolio", err));
  };

  const fetchTransactions = () => {
    axios.get(`${API_BASE_URL}/api/gold/transactions`, { params: { email } })
      .then(res => setTransactions(res.data))
      .catch(err => console.error("Failed to fetch transactions", err));
  };

  const handleLogout = () => {
    localStorage.removeItem('user_email');
    window.location.href = '/gold'; // or '/gold' to go back to landing
  };

  const handleSaveProfile = async () => {
    try {
      await axios.post(`${API_BASE_URL}/api/gold/user-info`, {
        email,
        name,
        mobile_no: mobile,
        pin_code: pinCode,
        delivery_address: address
      });
      setProfile({ email, name, mobile_no: mobile, pin_code: pinCode, delivery_address: address });
      setShowProfileModal(false);
    } catch {
      alert('Failed to save profile');
    }
  };

  const handleBuyGold = () => {
    setBuyMode("INR");
    setBuyValue("");
    setConfirmationData(null);
    setShowBuyModal(true);
  };

  if (showProfileModal) {
    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3>Complete Your Profile</h3>
          <input type="text" placeholder="Full Name" value={name} onChange={e => setName(e.target.value)} />
          <input type="text" placeholder="Mobile Number" value={mobile} onChange={e => setMobile(e.target.value)} />
          <input type="text" placeholder="Pin Code" value={pinCode} onChange={e => setPinCode(e.target.value)} />
          <textarea placeholder="Delivery Address" value={address} onChange={e => setAddress(e.target.value)} />
          <button className="action-btn" onClick={handleSaveProfile}>Save Profile</button>
        </div>
      </div>
    );
  }

const chartData = transactions.map(tx => ({
  date: new Date(tx.timestamp).toLocaleDateString(),
  value: parseFloat(tx.buy_price),
}));

  return ( 
    <div className="gold-container">
      <div className="gold-header">
        <h1>DiscountDost Gold</h1>
        <div>
          <span style={{ marginRight: '15px', color: '#555' }}>{email}</span>
          <button className="logout-btn" onClick={handleLogout}>Logout</button>
        </div>
      </div>

      {/* Not a card: Heading only */}
      <div className="gold-portfolio-header">
        <div>
          <div className="gold-section-title">Gold Portfolio</div>
          <div className="gold-description">Manage your digital gold investments</div>
        </div>
      </div>

      {/* Row 1: 3 cards */}
      <div className="card-grid-3">
        <div className="gold-card">
          <div className="card-title">
            Total Portfolio Value ({new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })})
          </div>
          <div className="card-value">
            ₹{portfolio ? portfolio.portfolio_value.toLocaleString() : '...'}
          </div>
        </div>
        <div className="gold-card">
          <div className="card-title">Total Gold Holdings</div>
          <div className="card-value">{portfolio ? portfolio.total_grams : '...'} grams</div>
        </div>
        <div className="gold-card">
          <div className="card-title">All-Time Returns</div>
          <div className="card-value">{portfolio ? `${portfolio.all_time_returns}%` : '...'}</div>
        </div>
      </div>

      {/* Row 2: 2 cards (graph + right side stacked) */}
      <div className="card-grid-2">
        <div className="gold-card">
          <div className="card-title">Performance Overview</div>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis dataKey="value" />
              <Tooltip />
              <Line type="monotone" dataKey="value" stroke="#ff9900" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className="gold-card">
          <div className="card-title">Quick Actions</div>
          <div className="actions-container">
            <button
              className="action-btn"
              onClick={() => {
                if (!profile) {
                  setShowProfileModal(true);
                } else {
                  handleBuyGold();  // existing buy logic
                }
              }}
            >
              Buy Gold
            </button>
            <button className="action-btn">Sell Gold</button>
            <button className="action-btn">Redeem Coupon</button>
          </div>
          <div style={{ marginTop: '20px' }} className="gold-card live-rate">
            <div className="card-title">Current Gold Rate</div>
            <div className="card-value">
              ₹{portfolio?.price_per_gram || '...'} / gram
              {/* Optional placeholder for % change */}
              {/* <small>(+0.8% today)</small> */}
            </div>
          </div>
        </div>
      </div>

      {/* Row 3: Full width transactions */}
      <div className="card-grid-1">
        <div className="gold-card transactions">
          <div className="card-title">Recent Transactions</div>
          <ul>
            {transactions.length === 0 ? (
              <li>No recent transactions</li>
            ) : (
              transactions.map((tx, index) => (
                <li key={index}>
                  <span>{new Date(tx.timestamp).toLocaleString()}</span>
                  <span>Buy Gold — ₹{tx.buy_price} ({tx.gold_amount}g)</span>
                </li>
              ))
            )}
          </ul>
        </div>
      </div>

      <div className="card-grid-1">
        <div className="gold-card rewards-full">
          <div className="card-title">Reward Summary</div>

          <div className="reward-item">
            <span><strong>Gold Redeemed:</strong> ₹1,500 / 0.72g</span>
          </div>

          <div className="reward-item">
            <span><strong>Gold Unredeemed:</strong> ₹950</span>
            <button
              className="action-btn"
              onClick={() => {
                if (!profile) {
                  setShowProfileModal(true);
                } else {
                  handleBuyGold(); // or replace with handleRedeemGold() if you separate logic later
                }
              }}
            >
              Redeem Now
            </button>
          </div>
        </div>
      </div>

      <div className="footer">
        © 2025 DiscountDost. All rights reserved. <br />
        Privacy Policy | Terms & Conditions
      </div>
      {showBuyModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            {!confirmationData ? (
              <>
                <h3>Buy Gold</h3>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    className="action-btn"
                    onClick={() => setBuyMode("INR")}
                    style={{ background: buyMode === "INR" ? "#d4af37" : "#ccc" }}
                  >
                    By Amount
                  </button>
                  <button
                    className="action-btn"
                    onClick={() => setBuyMode("GRAMS")}
                    style={{ background: buyMode === "GRAMS" ? "#d4af37" : "#ccc" }}
                  >
                    By Grams
                  </button>
                </div>
                <input
                  type="number"
                  placeholder={buyMode === "INR" ? "Enter amount in INR" : "Enter grams"}
                  value={buyValue}
                  onChange={(e) => setBuyValue(e.target.value)}
                />
                <button
                  onClick={async () => {
                    const val = parseFloat(buyValue);
                    if (isNaN(val) || val <= 0) return alert("Enter a valid number");

                    try {
                      const rateResp = await axios.get(`${API_BASE_URL}/api/gold/rate`);
                      const { current_price, tax_percent } = rateResp.data;
                      const buy_price = current_price * (1 + tax_percent / 100);

                      let grams, total;
                      if (buyMode === "INR") {
                        total = val;
                        grams = val / buy_price;
                      } else {
                        grams = val;
                        total = grams * buy_price;
                      }

                      const gst = total - (grams * current_price);

                      setConfirmationData({
                        rate: current_price,
                        buy_price,
                        grams,
                        gst,
                        total
                      });
                    } catch (err) {
                      alert("Failed to fetch gold rate");
                    }
                  }}
                >
                  Next
                </button>
                <button onClick={() => setShowBuyModal(false)}>Cancel</button>
              </>
            ) : (
              <>
                <h3>Confirm Purchase</h3>
                <p>Gold Rate: ₹{confirmationData.rate}/gm</p>
                <p>Gold Grams: {confirmationData.grams.toFixed(4)}g</p>
                <p>GST: ₹{confirmationData.gst.toFixed(2)}</p>
                <p><strong>Total: ₹{confirmationData.total.toFixed(2)}</strong></p>
                <button
                  onClick={async () => {
                    const phonepeOk = window.confirm("Mock PhonePe Payment\nPayment Successful?");
                    if (!phonepeOk) return alert("Payment cancelled");

                    try {
                      const res = await axios.post(`${API_BASE_URL}/api/gold/buy`, {
                        amount: confirmationData.total,
                        grams: buyMode === "GRAMS" ? confirmationData.grams : null,
                        user_info: profile
                      });

                      const { gold_amount, price_per_gram, tx_id } = res.data;

                      alert(`✅ Purchased ${gold_amount} grams at ₹${price_per_gram}/gm\nTxn ID: ${tx_id}`);
                      fetchPortfolio();
                      fetchTransactions();
                      setShowBuyModal(false);
                    } catch (err) {
                      console.error(err);
                      alert("Gold purchase failed");
                    }
                  }}
                >
                  Confirm & Pay
                </button>
                <button onClick={() => setShowBuyModal(false)}>Cancel</button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GoldPage;
